import React, { useState, useEffect } from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { timeToDateNumbers } from "../../../herramientas/DateFormat";
import Timer from "../../../herramientas/Time/setTimer";
import './Table.css';
/**
 * Lista de elementos json []
 * columnas (encabezados)
 * id (identificador de fila)
 * @param {*} param0 
 * @returns 
 */
let totalFiltrados= 0;
const TablePageable =({lista, columnas, id, selected, titulo, csvname, resaltarFuncion, resaltarColor, paginacion, elementosPorPagina,update=false,temporizador=12,accion,bitacora })=> {

  if(!lista) return "Sin registros";
  const [item, setItem] = useState({});
  const [listaTemp, setListaTemp] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalByPage, setTotalByPage] = useState(elementosPorPagina);
  const [search, setSearch] = useState("");
  const time = new Date();
  const [bandera,setBandera]= useState(false);

 
  time.setHours(temporizador);
  time.setMinutes(0);
  time.setSeconds(0);


  const handleFieldChange = (bandera) => {
    setBandera(bandera)
  };

  if(!columnas) return "sin columnas";
  const getDataToCsv=()=>{
    let csvDataTemp= []
    if(columnas.length){
      let columnasTemp= [];      
      for( let c of columnas ){
        c.label = c.label.replace('"', "''");
          if(c.label !== 'Actualizar'){
            columnasTemp.push(c.label);
          }
          
      }
      csvDataTemp.push(columnasTemp);
      for( let i of lista ){
      
        let columnasDataTemp= [];
        for( let c of columnas ){
            if(c.valor){
              let valorTemp= c.valor(i);
              if(valorTemp && typeof valorTemp === "string"){
                valorTemp= valorTemp.replace('"', "'");
                valorTemp= valorTemp.replace(/(\r\n|\n|\r)/gm, " ");
                valorTemp= valorTemp.replace(/(")/gm, "'");// .replace(',', '","');
              }
              columnasDataTemp.push(valorTemp);
            }else{//&& getValor(i, c.columna).includes('"')              
              let valorTemp= getValor(i, c.columna,c.label);
              if(valorTemp && (typeof valorTemp === "string") ){
                valorTemp= valorTemp.replace('"', "'");
                valorTemp= valorTemp.replace(/(\r\n|\n|\r)/gm, " ");
                valorTemp= valorTemp.replace(/(")/gm, "'");
              }
              if(typeof valorTemp !== 'object') columnasDataTemp.push(valorTemp);
            }
         
        }//;
        csvDataTemp.push(columnasDataTemp);
      }
    }    
    return csvDataTemp;
  }
  const getValor=(valor, nombre,label)=>{    
    
    const nombreTemp= nombre ? nombre.split("."): null;    
    if( nombreTemp ){
      if(1 === nombreTemp.length){
        
        if(label === "Comentarios"){
          return valor.remolques[0] ? valor.remolques[0].comentarios : "";
        }
        if(label === "Hora"){
          return valor.remolques[0] ? valor.remolques[0].fechaCreacion : "";
        }

        if(label === "Agregar"){
          return valor.remolques[0] ? valor.remolques[0].fechaCreacion : "";
        }



        return typeof valor[nombreTemp[0]] !== "object"? valor[nombreTemp[0]] :"";
      }
      if(2 === nombreTemp.length){
        return valor[nombreTemp[0]]? typeof valor[nombreTemp[0]][nombreTemp[1]] !== "object"? valor[nombreTemp[0]][nombreTemp[1]]: "": ""; 
      }
      if(3 === nombreTemp.length){
        return valor[nombreTemp[0]] ?
          valor[nombreTemp[0]][nombreTemp[1]]
            ? valor[nombreTemp[0]][nombreTemp[1]][nombreTemp[2]] !== "object"?  valor[nombreTemp[0]][nombreTemp[1]][nombreTemp[2]]: ""
          :""
        :"";
      }
    }

    if(nombre === ""){
      let valorTemp = valor.remolques.filter((remolque)=> {
        return remolque.nombre == (label);

      })

      if(valorTemp && valorTemp.length > 0 ){
        //console.log(valorTemp)
         valorTemp = valorTemp[0].totalDisponible > 0 ? valorTemp[0].totalDisponible : valorTemp[0].totalRegistrado ;
      }else {
        valorTemp = 0;
      }
      return valorTemp;
    }

      if(label === "Agregar"  && valor.remolques.length <= 0 && !bandera){
        return nombre;
      }

      if(label === "Agregar" && valor.remolques.length > 0){
        return valor.remolques[0].fechaCreacion;
      }
    
    
    if(label === "Actualizar"){
      return nombre;
    }

    return valor[nombre];
  }
  const getColumna=(registro, valor, i, splitBy, enClick, enClickDisabled, form)=>{
    let enClickDisabledTemp= enClickDisabled? enClickDisabled(registro):false;
    let formTemp= form? form(registro):null;
    switch (typeof valor) {
      case "string":    return (
      <td onClick={()=> { if(enClick && !enClickDisabledTemp) enClick(registro) }} className={enClick && !enClickDisabledTemp?"btn text-primary":""}>
        { splitBy?
          <ul>
            {valor.split(splitBy).map((v)=> <li>{v}</li>)}
          </ul>
          :form ? registro.remolques[0] ?  valor: !bandera ? formTemp : "" : valor
        }
      </td> );
      case "number":    return ( <td onClick={()=> { if(enClick && !enClickDisabledTemp) enClick(registro) }} className={enClick && !enClickDisabledTemp?"btn text-primary":""}> { form? formTemp: valor } </td>);
      break; 
      case "boolean":   return ( <td onClick={()=> { if(enClick && !enClickDisabledTemp) enClick(registro) }} className={enClick && !enClickDisabledTemp?"btn text-primary":""}> <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" id={"alive"+i.id} name={"alive"+i.id} checked={valor} /></div></td>);   
      break;
      default: 
      return (
        <td onClick={()=> { if(enClick && !enClickDisabledTemp) enClick(registro) }} className={enClick && !enClickDisabledTemp?"btn text-primary":""}>
          { splitBy?
            <ul>
              {valor.split(splitBy).map((v)=> <li>{v}</li>)}
            </ul>
            :form ? formTemp : valor
          }
        </td> );
        
    }
  }
  const filtro =(palabras = [], )=>{
    let x= search;
    for (let c of columnas) {
      //let y= palabras[c.columna];
      if( !c.form || (c.form && c.valor) ){
        let y= getValor(palabras, c.columna,c.label);
        if( y === null )
          y= "";
        if(typeof y === "number")
          y= getValor(palabras, c.columna,c.label).toString();
        if(typeof y === "boolean")
          y= getValor(palabras, c.columna,c.label).toString();
        /*
        //console.log("y "+typeof y+"["+c.columna+"] :"+ y);
        if( typeof y === "number" && y === Number(x) ){ return true }
        //if( typeof y === "boolean" && y && x ){ return true }
        if( typeof y === "string" && y.toUpperCase().includes(x.toUpperCase())){return true }
        */
        if(typeof x === "boolean" && typeof y === "boolean" && y && x ){ return true }
        let isMatch = new RegExp('(?:^|\\s)'+search, 'i').test(y);
        if(typeof y === "string" &&  isMatch){return true }
      }
    }
    return false;
  }
  const getPaginas=()=>{
    let paginasTemp= [];
    const totalPaginas= Math.ceil((Math.ceil(totalFiltrados)/totalByPage));
    for(let p=currentPage; p <= totalPaginas; p++){
      paginasTemp.push(
        <li className={"page-item"+(p===currentPage?" active":"")}>
          <a className="page-link"
          onClick={()=>{ if( currentPage< totalPaginas ){setCurrentPage(p)}}}>{p}</a>
        </li>);
      if(paginasTemp.length === 5)
        break;
    }
    return paginasTemp;
  }
  const getLista=()=>{
    let listaTemp= [...lista];
    let  x = item;
    if(listaTemp.length){
      listaTemp= listaTemp.filter(palabras => filtro(palabras) ).sort()
      totalFiltrados= listaTemp.length;
      if(paginacion)
        listaTemp= listaTemp.slice((currentPage*totalByPage)-(totalByPage), (currentPage*totalByPage));    
    }
  //  console.log(listaTemp)    
    return listaTemp; 

  }
  return (
    <div className="modern-table-container">
      <div className="table-header">
        <div className="header-content">
          <h3 className="table-title">{titulo}</h3>
          <div className="table-actions">
            <div className="search-wrapper">
              <i className="fa fa-search search-icon"></i>
              <input
                type="text"
                className="search-input"
                placeholder="Buscar..."
                value={search}
                onChange={(e)=> {
                  setSearch(e.target.value);
                  if(currentPage !== 1){
                    setCurrentPage(1);
                  }
                }}
              />
            </div>
            {csvname && (
              <CSVLink
                data={getDataToCsv()}
                filename={(csvname? csvname:"data")+"-"+timeToDateNumbers(new Date().getTime())+".csv"}
                className="csv-button"
              >
                <i className="fa fa-file-excel-o"></i>
                Exportar CSV
              </CSVLink>
            )}
            {bitacora && (
              <div className="bitacora-wrapper">
                {bitacora}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="table-content">
        <div className="table-wrapper">
          <table className="modern-table">
            <thead>
              <tr>
                {columnas.map((c)=> <th key={c[id]} className="table-header-cell">{c.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {lista?
                getLista().map((i, index) =>
                  <tr
                    key={i[id] || index}
                    className={`table-row ${
                      item && item[id] === i[id] ? 'selected' : ''
                    } ${
                      resaltarFuncion && resaltarFuncion(i) ? 'highlighted' : ''
                    }`}
                    onClick={()=>{ if(selected){ selected(i); } setItem(i)}}
                  >
                    {columnas.map((c, colIndex)=> 
                      <td key={colIndex} className="table-cell">
                        {getColumna(i, getValor(i, c.columna,c.label), i, c.splitBy, c.enClick, c.enClickDisabled, c.form)}
                      </td>
                    )}
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={columnas.length} className="empty-state">
                      <div className="empty-content">
                        <i className="fa fa-inbox empty-icon"></i>
                        <p>No hay datos disponibles</p>
                      </div>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
        <div className="table-footer">
          <div className="pagination-info">
            {paginacion && (
              <span className="info-text">
                Página {currentPage} de {Math.ceil(lista.length/totalByPage)} | 
                Total: {lista.length} elementos
              </span>
            )}
          </div>
          
          <div className="pagination-controls">
            <div className="page-size-control">
              <label>Mostrar:</label>
              <input
                type="number"
                className="page-size-input"
                value={totalByPage}
                onChange={(e)=> setTotalByPage(e.target.value)}
                min="1"
              />
              <span>por página</span>
            </div>
            
            <nav className="pagination-nav">
              <button 
                className={`page-btn ${currentPage <= 1 ? 'disabled' : ''}`}
                onClick={()=> currentPage > 1 && setCurrentPage(currentPage-1)}
                disabled={currentPage <= 1}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              
              <div className="page-numbers">
                {getPaginas().map((page, index) => (
                  <button 
                    key={index}
                    className={`page-number ${index === 0 ? 'active' : ''}`}
                    onClick={() => setCurrentPage(currentPage + index)}
                  >
                    {currentPage + index}
                  </button>
                ))}
              </div>
              
              <button 
                className={`page-btn ${currentPage >= Math.ceil(lista.length/totalByPage) ? 'disabled' : ''}`}
                onClick={()=> currentPage < Math.ceil(lista.length/totalByPage) && setCurrentPage(currentPage+1)}
                disabled={currentPage >= Math.ceil(lista.length/totalByPage)}
              >
                <i className="fa fa-chevron-right"></i>
              </button>
            </nav>
          </div>
          
          {!update && (
            <div className="timer-alert">
              <i className="fa fa-clock-o"></i>
              <span>El proceso de carga de remolques terminasss a las {temporizador} hrs</span>
              <Timer expiryTimestamp={time} bandera={handleFieldChange}/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default TablePageable;
